import Model from 'flarum/common/Model';
export default class PollOption extends Model {
  answer() {
    return Model.attribute('answer').call(this);
  }
  imageUrl() {
    return Model.attribute('imageUrl').call(this);
  }
  imageSrcset() {
    return Model.attribute('imageSrcset').call(this);
  }

  // Deprecated: read imageSrcset() presence instead.
  isImageUpload() {
    return Model.attribute('isImageUpload').call(this);
  }
  voteCount() {
    return Model.attribute('voteCount').call(this);
  }
  poll() {
    return Model.hasOne('polls').call(this);
  }
  votes() {
    return Model.hasMany('votes').call(this);
  }
}
flarum.reg.add('fof-polls', 'forum/models/PollOption', PollOption);